import React from 'react';
import { Badge } from '../../../components/ui/badge';
import { AlertTriangle, Check, Clock, Truck } from 'lucide-react';
import { fmtTime, positionStyle } from '../../../lib/scheduleFormat';

// One shift as it appears in the builder. Status is carried by text as well as
// colour, so colour is never the only signal.
const ShiftChip = ({ shift, onClick }) => (
  <button
    type="button"
    onClick={() => onClick(shift)}
    className={`w-full rounded-md border px-2 py-1.5 text-left text-xs transition-shadow hover:shadow-sm ${positionStyle(shift.position_code)}`}
    data-testid={`shift-chip-${shift.id}`}
  >
    <span className="flex items-center justify-between gap-1 font-medium">
      <span className="truncate">
        {shift.kitchen_bound ? shift.position_label : (
          <><Truck className="mr-0.5 inline h-3 w-3" />{shift.position_label}</>
        )}
      </span>
      {shift.status === 'draft' && (
        <span className="rounded bg-white/70 px-1 text-[10px] uppercase tracking-wide">draft</span>
      )}
    </span>
    <span className="mt-0.5 block truncate opacity-90">
      {fmtTime(shift.start_time)}–{fmtTime(shift.end_time)}
    </span>
    {shift.previous && (
      <span className="mt-0.5 block truncate text-[11px] opacity-80">
        <s>{fmtTime(shift.previous.start_time)}–{fmtTime(shift.previous.end_time)}</s>
      </span>
    )}
    {!shift.kitchen_bound && shift.pickup_time && (
      <span className="mt-0.5 block truncate opacity-90">pickup {fmtTime(shift.pickup_time)}</span>
    )}
    <span className="mt-1 flex flex-wrap items-center gap-1">
      {shift.status === 'published' && shift.confirmed && (
        <Badge variant="outline" className="h-4 border-emerald-300 bg-white/80 px-1 text-[10px] text-emerald-700">
          <Check className="mr-0.5 h-2.5 w-2.5" /> confirmed
        </Badge>
      )}
      {shift.status === 'published' && !shift.confirmed && (
        <Badge variant="outline" className="h-4 border-amber-300 bg-white/80 px-1 text-[10px] text-amber-800">
          <Clock className="mr-0.5 h-2.5 w-2.5" /> {shift.needs_reconfirm ? 'reconfirm' : 'unconfirmed'}
        </Badge>
      )}
      {shift.conflict && (
        <Badge variant="outline" className="h-4 border-red-300 bg-white/80 px-1 text-[10px] text-red-700">
          <AlertTriangle className="mr-0.5 h-2.5 w-2.5" /> conflict
        </Badge>
      )}
    </span>
  </button>
);

export default ShiftChip;
